import { z } from "zod";

export const SuperadminControllerResponseSchema = {
  adminNotify: z.boolean(),

  backup: z.void(),

  restore: z
    .array(
      z.object({
        type: z.string(),
        path: z.string(),
        error: z.unknown(),
      })
    )
    .or(z.null()),

  integrityCheck: z.string().array(),

  clearCache: z.boolean(),
};
